module.exports = __webpack_public_path__ + "img/rt.-rev.-richard-allen.4aa66cc9.png";